// export const apiUrl = 'http://localhost:8080';

export const apiUrl = 'https://hrobecky.ddns.net';
export const testUrl = 'https://turistika-test.netlify.app';
// export const mapaUrl = 'http://localhost:8083/';
export const mapaUrl = 'https://turistika-mapa.netlify.app/';


